import { useQuery } from '@tanstack/react-query';

import { api } from '@/api/client';
import type { SharePointDocument } from '@/api/types';

/** `productId` is the product's own id (ProductSummary.id), not its BP/PIM number: the
 * server expands it into every code the Document Lake might have filed a document under.
 * `countryCode` is the alpha-3 code from the country picker. */
export function useProductDocuments(productId: string, countryCode: string) {
  return useQuery({
    queryKey: ['product-documents', productId, countryCode],
    queryFn: async () =>
      (
        await api.get<Array<SharePointDocument>>(`/products/${productId}/documents`, {
          params: countryCode ? { country: countryCode } : undefined,
        })
      ).data,
    enabled: Boolean(productId),
  });
}
